'use client';
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useHydrateAtoms } from './use-hydrate-atoms.js';
export function HydrationBoundary({ children, hydrateAtoms, options, }) {
    useHydrateAtoms(hydrateAtoms, options);
    return _jsx(_Fragment, { children: children });
}
